(function (angular) {
    angular
        .module('app.purchase')
        .controller('app.purchase.ChoosePlanController', [
            '$scope',
            '$state',
            'app.purchase.purchaseFlowService',
            '$uibModal',
            'ui',
            controller
        ]);
    function controller($scope, $state, service, $uibModal, ui) {
        var vm = this;

        vm.siteContent = siteContent;
        vm.plans = siteContent.planOptions;
        vm.selectPlan = selectPlan;

        function selectPlan(selection) {
            ui.block();
            service
                .setPlanSelection(selection, vm.siteContent.theme)
                .then(function () {
                    if ($state.current.name.indexOf('app.sgdpppurchase') == 0) {
                        $state.go('app.sgdpppurchase.applicants');
                    }
                    else { 
                        $state.go('app.purchase.applicants');
                    }
                })
                .finally(function () {
                    ui.unblock();
                });
        }
    }
})(angular);
